module.exports = __webpack_public_path__ + "img/50.f84762e9.png";